import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PDFViewer = ({ pdfUrl, submission }) => {
  const [zoom, setZoom] = useState(100);

  const handleZoomIn = () => {
    if (zoom < 200) setZoom(zoom + 25);
  };

  const handleZoomOut = () => {
    if (zoom > 50) setZoom(zoom - 25);
  };

  const handleResetZoom = () => {
    setZoom(100);
  };

  return (
    <div className="h-full flex flex-col">
      {/* Toolbar */}
      <div className="px-4 py-2 border-b border-border bg-muted/30 flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleZoomOut}
            disabled={zoom <= 50}
            iconName="ZoomOut"
          />
          <span className="text-xs font-medium text-muted-foreground min-w-[40px] text-center">
            {zoom}%
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleZoomIn}
            disabled={zoom >= 200}
            iconName="ZoomIn"
          />
          <button
            onClick={handleResetZoom}
            className="text-xs text-muted-foreground hover:text-foreground px-2 py-1 transition-colors"
          >
            Reset
          </button>
        </div>

        {pdfUrl && (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground px-2 py-1 transition-colors"
          >
            <Icon name="ExternalLink" size={14} />
            Open in new tab
          </a>
        )}
      </div>

      {/* Submission file display */}
      <div className="flex-1 overflow-auto bg-muted/10">
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            className="w-full h-full border-0"
            style={{ minHeight: '100%' }}
            title="Submission file"
          />
        ) : (
          <div className="flex items-center justify-center h-full py-20">
            <div className="text-center space-y-3">
              <div className="w-14 h-14 bg-muted flex items-center justify-center mx-auto">
                <Icon name="FileText" size={24} className="text-muted-foreground" />
              </div>
              <p className="text-sm text-muted-foreground">No submission file available for this submission</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFViewer;
